import { useContext } from 'react';

import { BasicData } from '@App';

import './style.scss';
import '@assets/fonts/socials/socials-font-icons.scss'
import { getColor, getTextColorClass } from '@utils/Utils';

const FooterComponent = () => {
    const { name, start_date, end_date, branding, theme } = useContext(BasicData);  

    const colors = getColor(theme);

    const onSocialMediaClick = (link) => {
        window.open(link, "_blank");
    }

    return (
        <div className={`footer ${getTextColorClass(colors?.secondary)}`}>
            <div className="footer-name-dates-container">
                <h6 className="footer-name">{name}</h6>
                {(start_date && end_date) && <h6 className="footer-dates">{start_date} - {end_date}</h6>}
            </div>
            <div className="footer-social-media-icons-container">

                {branding?.facebook && (
                    <i className={`icon-facebook-${theme.social_media_icon_style.toLowerCase()}`} onClick={() => onSocialMediaClick(branding.facebook)}>
                        <span className='path1' />
                        <span className='path2' />
                    </i>
                )}
                {branding?.twitter && (
                    <i className={`icon-social-x-${theme.social_media_icon_style.toLowerCase()}`} onClick={() => onSocialMediaClick(branding.twitter)}>
                        <span className='path1' />
                        <span className='path2' />
                    </i>
                )}
                {branding?.youtube && (
                    <i className={`icon-youtube-${theme.social_media_icon_style.toLowerCase()}`} onClick={() => onSocialMediaClick(branding.youtube)}>
                        <span className='path1' />
                        <span className='path2' />
                    </i>
                )}
                {branding?.instagram && (
                    <i className={`icon-instagram-${theme.social_media_icon_style.toLowerCase()}`} onClick={() => onSocialMediaClick(branding.instagram)}>
                        <span className='path1' />
                        <span className='path2' />
                        <span className='path3' />
                        <span className='path4' />
                    </i>
                )}
                {branding?.pinterest && (
                    <i className={`icon-pinterest-${theme.social_media_icon_style.toLowerCase()}`} onClick={() => onSocialMediaClick(branding.pinterest)}>
                        <span className='path1' />
                        <span className='path2' />
                    </i>
                )}
            </div>
        </div>
    )
}

export default FooterComponent